
/* styles */
require("!!../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-65914c75&scoped=true!sass-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./result-activate-tag.vue")

var Component = require("!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./result-activate-tag.vue"),
  /* template */
  require("!!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-65914c75!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./result-activate-tag.vue"),
  /* scopeId */
  "data-v-65914c75",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/result-activate-tag.vue
// module id = 1935
// module chunks = 1